//INPUTS HANDLERS

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

$('input[data-allow-paste="false"]').on('paste', function (e) {
    e.preventDefault();
});

$('.form-wrap .submit-wrap .button').on('click', function (e) {
    e.preventDefault();

    var closestForm = $(this).closest('.form-wrap');
    var valElements = closestForm.find('.validatable');

    closestForm.addClass('loading');

    var phoneValid = true;
    var emailValid = true;
    var checkbox1Valid = true;
    var checkbox2Valid = true;

    closestForm.find('.error').hide();
    valElements.each(function (ind, el) {

        if ($(el).attr('name') === 'email') {

            if ($(el).val() === '') {
                $(el).addClass('wpcf7-not-valid');
                $(el).closest('.input-wrap').find('.error.error-required').show();
                emailValid = false;
            } else {
                $(el).removeClass('wpcf7-not-valid');
                emailValid = true;

                if (!validateEmail($(el).val())) {
                    $(el).addClass('wpcf7-not-valid');
                    $(el).closest('.input-wrap').find('.error.error-email').show();
                    emailValid = false;
                } else {
                    $(el).removeClass('wpcf7-not-valid');
                    emailValid = true;
                }
            }

        } else if ($(el).attr('name') === 'user-name') {

            if ($(el).val() === '') {
                $(el).addClass('wpcf7-not-valid');
                $(el).closest('.input-wrap').find('.error.error-required').show();
                phoneValid = false;
            } else {
                $(el).removeClass('wpcf7-not-valid');
                phoneValid = true;
            }

        } else if ($(el).attr('name') === 'phone') {

            if ($(el).val() === '') {
                $(el).addClass('wpcf7-not-valid');
                $(el).closest('.input-wrap').find('.error.error-required').show();
                phoneValid = false;
            } else {
                $(el).removeClass('wpcf7-not-valid');
                phoneValid = true;
            }

        } else if ($(el).attr('id') === 'checkbox1') {

            if (!$(el).is(':checked')) {
                $(el).closest('.checkbox-wrap').addClass('wpcf7-not-valid');
                checkbox1Valid = false;
            } else {
                $(el).closest('.checkbox-wrap').removeClass('wpcf7-not-valid');
                checkbox1Valid = true;
            }

        } else if ($(el).attr('id') === 'checkbox2') {

            if (!$(el).is(':checked')) {
                $(el).closest('.checkbox-wrap').addClass('wpcf7-not-valid');
                checkbox2Valid = false;
            } else {
                $(el).closest('.checkbox-wrap').removeClass('wpcf7-not-valid');
                checkbox2Valid = true;
            }

        }

    });

    if (emailValid && phoneValid && checkbox1Valid && checkbox2Valid) {
        $('.wpcf7-submit').click();
    }else {
        closestForm.removeClass('loading');
    }

});

$('label[for=checkbox1]').on('click', function () {
    if ($('#checkbox1').is(':checked')) {
        $('label[for=checkbox1]').removeClass('active');
    } else {
        $('label[for=checkbox1]').addClass('active');
    }
});

$('label[for=checkbox2]').on('click', function () {
    if ($('#checkbox2').is(':checked')) {
        $('label[for=checkbox2]').removeClass('active');
    } else {
        $('label[for=checkbox2]').addClass('active');
    }
});

//INPUTS HANDLERS

var onSentBad = function () {

    },
    onSentOk = function(event){
        var eventID = event.detail.contactFormId;

        if(eventID !== 6){
            $('.full, .focus, .error').removeClass('focus full error');

            var form = $('[id^=wpcf7-f'+ eventID +'] .wpcf7-form');

            setTimeout(function () {
                form.removeClass('sent');
            }, 10000)
        }
    },
    onSubmit = function(event){

        var eventID = event.detail.contactFormId;

        if(eventID !== 6) {

            var input = $('.wpcf7').find('input, textarea');
            for (var i = 0; i < input.length; i++) {
                if (input.eq(i).hasClass('wpcf7-not-valid')) {
                    input.eq(i).closest('.input').addClass('error').find('.wpcf7-not-valid-tip');
                }
            }

        }
    };

$(document).on('wpcf7submit', onSubmit);
$(document).on('wpcf7mailsent', onSentOk);
$(document).on('wpcf7mailfailed', onSentBad);

var inputs = $('textarea, input');

inputs.on('change keyup keydown keypress', function(){
    if ($.trim(this.value).length > 0) {
        $(this).closest('.input, .file-div').addClass('full');
        $(this).removeClass('wpcf7-not-valid').closest('.input, .file-div').removeClass('error');
    } else {
        $(this).closest('.input, .file-div').removeClass('full');
    }
});

inputs.on('focusin', function(){
    $(this).closest('.input').addClass('focus');
});

inputs.on('focusout', function(){
    $(this).closest('.input').removeClass('focus');
});

var tryoutForm = $('.tryout-page form');

tryoutForm.on('submit', function (e) {
    e.preventDefault();

    var form = $(this),
        inputs = form.find('.input, .checkbox-wrap'),
        ready = true;

    for(var a=0; a<inputs.length; a++){
        if(inputs.eq(a).hasClass('error')){
            ready = false;
        }
    }

    if(!ready){
        return false;
    }

    tryoutForm.addClass('loading');

    var data = form.serialize();

    pd = new FormData();
    pd.append('action', 'validate_tryout_form');
    pd.append('data', data);

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            // console.log(response)

            var data = response.data;

            if(data.hasErrors){

                var errors = data.errors;

                for(var a=0; a<errors.length; a++){
                    var error = errors[a];

                    var input = form.find('[name='+ error['input'] +']');

                    var wrap = input.closest('.input, .checkbox-wrap');

                    wrap.addClass('error');

                    wrap.prepend('<div class="error-explain">'+ error['error'] +'</div>');
                }

                tryoutForm.removeClass('loading');

            } else {

                //success

                $('.info-block').hide();
                $('.success-block').show();

                tryoutForm.removeClass('loading');

            }
        }
    });

});

var outsideForm = $('.outside-page form');

outsideForm.on('submit', function (e) {
    e.preventDefault();

    var form = $(this),
        inputs = form.find('.input, .checkbox-wrap'),
        ready = true;

    for(var a=0; a<inputs.length; a++){
        if(inputs.eq(a).hasClass('error')){
            ready = false;
        }
    }

    if(!ready){
        return false;
    }

    outsideForm.addClass('loading');

    var data = form.serialize();

    pd = new FormData();
    pd.append('action', 'validate_outside_form');
    pd.append('data', data);

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            // console.log(response)

            var data = response.data;

            if(data.hasErrors){

                var errors = data.errors;

                for(var a=0; a<errors.length; a++){
                    var error = errors[a];

                    var input = form.find('[name='+ error['input'] +']');

                    var wrap = input.closest('.input, .checkbox-wrap');

                    wrap.addClass('error');

                    wrap.prepend('<div class="error-explain">'+ error['error'] +'</div>');
                }

                outsideForm.removeClass('loading');

            } else {

                //success

                $('.info-block').hide();
                $('.success-block').show();

                outsideForm.removeClass('loading');

            }
        }
    });

});